import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Box, Grid} from '@material-ui/core';
import {t} from "ttag";
import {AirportSelector, TabBarUnderlined, FlightsTable,} from "../../../index";
import {SW_FLIGHT_STATUS_REAL_TIME_STATUS_TABS} from "../../../../store/types";
import CircularProgress from "@material-ui/core/CircularProgress";

const RealTimeFlightStatus = ({airports, selectedAirport, selectedTab, onAirportSelect, onTabSelect, flights, loadRealTimeFlightsFn, loading}) => {

    const [showAllFlights, setShowAllFlights] = useState(false);

    useEffect(() => {
        loadRealTimeFlightsFn();
        // eslint-disable-next-line
    }, [selectedAirport]);

    return (
        <Box className={'sw-flight-status-real-time-data-container'} id={'sw-flight-status-real-time-data-container'} borderRadius={'6px'} bgcolor={'#fff'}>
            <Grid spacing={1} container>
                <Grid xs={12} sm={12} md={12} onDoubleClick={() => setShowAllFlights(prevState => !prevState)} item>
                    <Box color={'primary.main'} fontSize={'h6.fontSize'} fontFamily={'NeoSansMedium'}>
                        {t`Real Time Flights From:`}
                    </Box>
                </Grid>
                <Grid xs={12} sm={12} md={12} item>
                    <AirportSelector
                        label={t`Select airport`}
                        placeholder={t`Select or type an airport name...`}
                        options={airports}
                        onChange={onAirportSelect}
                        value={selectedAirport}
                        loading={loading}
                        hideIcon
                        flat
                    />
                </Grid>
                {!loading && (
                    <Grid xs={12} sm={12} md={12} item>
                        <TabBarUnderlined
                            tabs={[
                                {
                                    label: t`ARRIVALS`,
                                    value: SW_FLIGHT_STATUS_REAL_TIME_STATUS_TABS.ARRIVALS,
                                },
                                {
                                    label: t`DEPARTURES`,
                                    value: SW_FLIGHT_STATUS_REAL_TIME_STATUS_TABS.DEPARTURES,
                                },
                            ]}
                            selected={selectedTab}
                            onSelect={(e, v) => onTabSelect(v)}
                        />
                    </Grid>
                )}
                {!loading && (
                    <Grid xs={12} sm={12} md={12} item>
                        <FlightsTable
                            flights={flights}
                            columnTitles={{
                                datetime: t`Hour`,
                                flightNumber: t`Flight`,
                                airport: selectedTab === SW_FLIGHT_STATUS_REAL_TIME_STATUS_TABS.ARRIVALS ? t`Origin` : t`Destination`,
                                status: t`Status`,
                            }}
                            t={s => {
                                const statuses = {
                                    'On schedule': t`On schedule`,
                                    'Ahead of schedule': t`Ahead of schedule`,
                                    'Departed': t`Departed`,
                                    'Arrived': t`Arrived`,
                                    'Delayed': t`Delayed`,
                                    'Diverted': t`Diverted`,
                                    'Cancelled': t`Cancelled`,
                                };
                                return statuses.hasOwnProperty(s) ? statuses[s] : s;
                            }}
                            limitFlights={showAllFlights ? false : 5}
                        />
                    </Grid>
                )}
                {loading && (
                    <Grid xs={12} sm={12} md={12} item>
                        <Box display={'flex'} borderRadius={'6px'} border={'1px solid #f0f0f0'} justifyContent={'center'} alignItems={'center'} minHeight={'280px'}>
                            <CircularProgress color={'secondary'}/>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

RealTimeFlightStatus.propTypes = {
    airports: PropTypes.array,
    selectedTab: PropTypes.oneOf(Object.values(SW_FLIGHT_STATUS_REAL_TIME_STATUS_TABS)),
    selectedAirport: PropTypes.object,
    onAirportSelect: PropTypes.func,
    onTabSelect: PropTypes.func,
    flights: PropTypes.array,
    loadRealTimeFlightsFn: PropTypes.func,
    loading: PropTypes.bool,
};

RealTimeFlightStatus.defaultProps = {
    airports: [],
    selectedTab: SW_FLIGHT_STATUS_REAL_TIME_STATUS_TABS.ARRIVALS,
    selectedAirport: null,
    onAirportSelect: () => null,
    onTabSelect: () => null,
    flights: [],
    loadRealTimeFlightsFn: () => null,
    loading: false,
};

export default RealTimeFlightStatus;